import React from "react";
import verificationpic from "../../../../assets/images/thanks.png";
import Button from "../../Button/Button";
import Modal from "../Modal/Modal";
import styles from "../ThanksModal/ThanksModal.module.scss";
import { KycApproveIcon } from "../../../../assets/icons/svgicons";

const ThankyouStripeModal = ({ show, handleClose }) => {
  return (
    <Modal
      className={styles.thanks_modal}
      show={show}
      handleClose={handleClose}
      title={true}
    >
      <div className={styles.direct_sec}>
        <div className={styles.deposit_img}>
          {/* <img src={verificationpic} alt="man-with-magnifier-glass" /> */}
          <KycApproveIcon />
        </div>
        <h2 className="smallText">Completed</h2>
        <p>
          Congratulations! Your account has been successfully added. Now your
          Stripe account is added to STBL account.
        </p>
      </div>
      <Button
        fluid
        variant="secondary_btn"
        className={styles.submit_btn}
        onClick={handleClose}
      >
        Done
      </Button>
    </Modal>
  );
};

export default ThankyouStripeModal;
